import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';



import * as PublicComponents from './components';
import { PublicRoutingModule } from './public-routing.module';

@NgModule({
    declarations: [...PublicComponents.components],
    imports: [SharedModule, PublicRoutingModule],
    exports: [],
})
export class PublicModule { }
